import React, { useCallback, useEffect, useState } from "react";
import "../../App.css";
import "../../profile.css";
import { useNavigate } from "react-router-dom";
import service from "../../services/service";
import endpoints from "../../services/endpoints";

const Rewards = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [challenges, setChallenges] = useState([]);

const fetchChallenges = useCallback(async () => {
  try {
    setLoading(true);

    const response = await service.get(
      endpoints.rewards.challengeList
    );

    console.log("Rewards API:", response);

    const challengeList = Array.isArray(
      response?.data?.data?.data
    )
      ? response.data.data.data
      : [];

    setChallenges(challengeList);
  } catch (error) {
    console.error("Failed to fetch challenges:", error);
    setChallenges([]);
  } finally {
    setLoading(false);
  }
}, []);

  useEffect(() => {
    fetchChallenges();
  }, [fetchChallenges]);

  const getStatusClass = (status) => {
    switch (status) {
      case "COMPLETED":
        return "rewardsPage-statusCompleted";

      case "PAUSED":
        return "rewardsPage-statusUpcoming";

      case "INITIATED":
        return "rewardsPage-statusInitiated";
      case "IN_PROGRESS":
        return "rewardsPage-statusInprogress";
      default:
        return "rewardsPage-statusInprogress";
    }
  };

  return (
    <div className="rewardsPage-container">
      <div className="rewardsPage-header">
        <h1>Checkpoints</h1>
      </div>

      {loading ? (
        <div className="rewardsPage-empty">
          Loading Challenges...
        </div>
      ) : challenges.length === 0 ? (
        <div className="rewardsPage-empty">
          No Challenges Found
        </div>
      ) : (
        <div className="rewardsPage-grid">
          {challenges.map((challenge) => (
            <div
              key={challenge.challengeId}
              className="rewardsPage-card"
              onClick={() =>
                navigate(`/rewards/${challenge.challengeId}`, {
                  state: challenge,
                })
              }
            >
              
              <div
                className={`rewardsPage-status ${getStatusClass(
                  challenge.status || "INITIATED"
                )}`}
              >
                {(challenge.status || "INITIATED").replaceAll(
                  "_",
                  " "
                )}
              </div>

              <div className="rewardsPage-cardBody">
                <h3>{challenge.challengeName}</h3>

                <p>
                  {challenge.shortDescription ||
                    "No description available."}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Rewards;